import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { ArrowRight, Shield } from 'lucide-react';
import { rolesService } from '@/services/roles.service';
import { Card, CardContent } from '@/components/ui/card';

export function RolesListPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['roles'],
    queryFn: () => rolesService.list(),
  });

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Roles &amp; Permissions</h1>
        <p className="text-sm text-muted-foreground">
          5 fixed roles. Click any to edit its permissions or default modules. Per-user module visibility
          is set on the Staff Detail page, not here.
        </p>
      </div>

      {isLoading ? (
        <div className="rounded-lg border border-border/60 bg-card p-8 text-center text-muted-foreground">
          Loading…
        </div>
      ) : (
        <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
          {(data ?? []).map((role) => (
            <Link key={role.code} to={`/system/roles/${role.code}`}>
              <Card className="transition hover:border-primary/50 hover:shadow-md">
                <CardContent className="flex items-center gap-4 p-5">
                  <div className="rounded-lg border border-border/60 bg-primary/10 p-2 text-primary">
                    <Shield className="h-5 w-5" />
                  </div>
                  <div className="flex-1 space-y-0.5">
                    <div className="text-sm font-medium tracking-tight">{role.name}</div>
                    <div className="font-mono text-xs text-muted-foreground">{role.code}</div>
                    <div className="text-xs text-muted-foreground">
                      {role.permission_count} permissions · {role.default_module_count} default
                      modules
                    </div>
                  </div>
                  <ArrowRight className="h-4 w-4 text-muted-foreground" />
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
